module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/solution-01_sp-3d5546e92db140d6c43815ddbf6efe17.jpg";